import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MusicCoreService } from './music-core.service';
import { MusicSelectorComponent } from './music-selector/music-selector.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [MusicSelectorComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  providers: [MusicCoreService],
  exports: [MusicSelectorComponent],
})
export class MusicCoreModule {}
